import React from "react";
import AddIcon from "../UIComponents/AddIcon";
import { connect } from "react-redux";
import { withRouter } from "react-router-dom";
import { searchShipMgmt, getShipDetails } from "../Actions/ShipManagementAPI";
import ShipManagementCard from "../components/ShipManagementCard";
import Role from "../helpers/role";

let userRole = localStorage.getItem("UserRoles");

class ShipManagement extends React.Component {
  constructor(props) {
    super(props);
    this.state = {
      searchShip: {
        ShipName: "",
        PageNumber: 1,
        PageSize: 25,
        isActive: true,
        isInactive: false,
        isAll: false
      },
    };
    this.SearchShip = this.SearchShip.bind(this);
    this.ClearInput = this.ClearInput.bind(this);
    this.handleInputChange = this.handleInputChange.bind(this);
  }

  componentDidMount() {
    this.props.dispatch({ type: "SubBannerTitle", data: "Ship Management" });
    this.props.dispatch(searchShipMgmt(this.state.searchShip));
  }

  SearchShip(Pgno) {
    const { dispatch } = this.props;
    this.state.searchShip.PageNumber = Pgno;
    dispatch(searchShipMgmt(this.state.searchShip));
  }

  eyeclick(item) {
    const { dispatch, history } = this.props;
    dispatch({ type: "ShowSidePan", data: true });
    dispatch({ type: "ShipDetails", data: item });
    dispatch(getShipDetails(item.shipId));
    history.push(`/Home/Management/Ship/${item.shipId}`);
    window.scrollTo(0, 0);
  }

  NewitemNav = () => {
    this.props.history.push("/Home/Management/ShipAdd");
  };

  ShowSidePanel = () => {
    this.setState({ showSidePane: false });
    this.props.dispatch({ type: "ShowSidePan", data: false });
  };

  // handleInputChange(e) {
  //     let nodeName = e.target.name
  //     this.state.searchShip[nodeName] = e.target.value;
  //     this.setState({});
  // }
  handleInputChange(e) {
    this.state.searchShip.ShipName = e.target.value;
    if (e.target.value === "") {
      this.props.dispatch(searchShipMgmt(this.state.searchShip));
    }
    this.setState({});
  }

  ClearInput() {
    this.state.searchShip.ShipName = "";
    this.state.searchShip.isActive = true;
    this.state.searchShip.isInactive = false;
    this.state.searchShip.isAll = false;
    this.props.dispatch(searchShipMgmt(this.state.searchShip));
    this.setState({});
  }

  handleRadioInputChange(e) {
    let name = e.target.name;
    if (name == "Active") {
      this.setState(prevState => ({
        searchShip: {
          ...prevState.searchShip,
          isActive: true,
          isInactive: false,
          isAll: false
        }
      }));
    }
    if (name == "Inactive") {
      this.setState(prevState => ({
        searchShip: {
          ...prevState.searchShip,
          isActive: false,
          isInactive: true,
          isAll: false
        }
      }));
    }
    if (name == "All") {
      this.setState(prevState => ({
        searchShip: {
          ...prevState.searchShip,
          isActive: false,
          isInactive: false,
          isAll: true
        }
      }));
    }
  }

  BacktoPrevious() {
    this.props.history.goBack();
  }

  render() {
    const { SearchShip } = this.props;
    return (
      <div className="full-height">
        <div className="pt-3">
          <div className="row px-3 pb-3">
            <button
              className="btn btn-primary text-uppercase txtside-btn txtht-btn blue"
              onClick={() => this.BacktoPrevious()}
            >
              <div style={{ position: 'relative' }}>
                <span className="backarr">&larr;</span> <span style={{ marginLeft: "18px" }}>Back</span>
              </div>
            </button>
          </div>
          <div className="row">
            <div className="col-lg-12">
              <div className="panel-box">
                <div
                  className="card MM-card-header mb-0"
                  style={{ backgroundColor: "white" }}
                >
                  <div
                    className="card-body flex"
                    style={{
                      padding: "0rem",
                      backgroundColor: "#1a3464",
                      color: "white",
                    }}
                  >
                    <h5
                      className="card-title ml-2 mt-2 f2"
                      style={{ color: "092a51" }}
                    >
                      Ship Management
                    </h5>
                    {userRole == Role.mmpl ? (<></>) : (<>
                      <div className="m-1 flex" onClick={this.NewitemNav}>
                        <span className="mt-1">Add Ship</span>
                        <AddIcon />
                      </div>
                    </>)}
                  </div>
                </div>
                <div className="search-filter-box">
                  <div className="row">
                    <div className="col-lg-3 ">
                      <label className="form-label">Ship Name</label>
                      <br></br>
                      <input
                        className="form-control"
                        type="text"
                        name="ShipName"
                        placeholder="Ship Name"
                        value={this.state.searchShip.ShipName}
                        onChange={(e) => this.handleInputChange(e)}
                      ></input>
                    </div>
                    <div className="col-lg-6">
                      <label className="form-label">Status</label>
                      <br></br>
                      <div className="row">
                        <div className="col-12">
                          <span className="mr-4">
                            <input
                              type="radio"
                              name="Active"
                              onChange={(e) => this.handleRadioInputChange(e)}
                              checked={this.state.searchShip.isActive}
                            ></input>
                            <label className="radioButton">Active</label>
                          </span>
                          <span className="mr-4">
                            <input
                              type="radio"
                              name="Inactive"
                              onChange={(e) => this.handleRadioInputChange(e)}
                              checked={this.state.searchShip.isInactive}
                            ></input>

                            <label className="radioButton">Inactive</label>
                          </span>
                          <span>
                            <input
                              type="radio"
                              name="All"
                              onChange={(e) => this.handleRadioInputChange(e)}
                              checked={this.state.searchShip.isAll}
                            ></input>
                            <label className="radioButton">All</label>
                          </span>
                        </div>
                      </div>
                    </div>
                    <div className="col-lg-3">
                      <label></label>
                      <br></br>
                      <div
                        className="form-group mt-3 search-btn-col"
                        style={{ textAlign: "end" }}
                      >
                        <button
                          className="btn btn-primary text-uppercase txtside-btn txtht-btn blue"
                          type="submit"
                          onClick={() => this.SearchShip(1)}
                        >
                          Search
                        </button>
                        <button
                          className="btn btn-light text-uppercase txtside-btn txtht-btn ml-3"
                          type="button"
                          onClick={() => this.ClearInput()}
                        >
                          {" "}
                          Clear{" "}
                        </button>
                      </div>
                    </div>
                  </div>
                </div>
              </div>
            </div>
          </div>
          {/* <div className="row">
                                <div className="col-lg-12">
                                    <div className="panel-box">
                                        <div className="card MM-card-header mb-0" style={{ backgroundColor: "white" }}>
                                            <div className="card-body flex" style={{ padding: "0rem", backgroundColor: "#1a3464", color: "white" }}>
                                                <h5 className="card-title ml-2 mt-2" style={{ color: "092a51" }}>
                                                    Ship Management
                                                </h5>
                                                <div className="m-1 flex" onClick={this.NewitemNav}>
                                                    <span className="card-title m-auto">Add Ship</span><AddIcon />
                                                </div>
                                            </div>
                                        </div>
                                        <div className="search-filter-box">
                                            <div className="row">
                                                <div className="col-lg-4">
                                                    <label className="form-label" >Ship Name</label><br></br>
                                                    <input className="form-control" type="text" name="Shipname" value={this.state.searchShip.ShipName} placeholder="Ship Name" onChange={e => this.handleInputChange(e)}></input>
                                                </div> */}
          {/* <div className="col-lg-4">
                                                    <label className="form-label" >IMO No</label><br></br>
                                                    <input className="form-control" type="text" name="shipname" value={this.state.searchShip.imoNo} placeholder="IMO No" onChange={e => this.handleInputChange(e)}></input>
                                                </div>
                                                <div className="col-lg-4">
                                                    <label className="form-label" >Mail ID</label><br></br>
                                                    <input className="form-control" type="text" name="shipname" value={this.state.searchShip.Mail} placeholder="Mail ID" onChange={e => this.handleInputChange(e)}></input>
                                                </div>
                                                <div className="col-lg-6">
                                                    <label className="form-label" >Ship Management Company Mail Id</label><br></br>
                                                    <input className="form-control" type="text" name="shipname" value={this.state.searchShip.shippingCompanyMail} placeholder="Ship Management Company Mail Id" onChange={e => this.handleInputChange(e)}></input>
                                                </div> */}
          {/* <div className="col-lg-6">
                                                    <label></label><br></br>
                                                    <div className="form-group mt-3 search-btn-col" style={{ textAlign: "end" }}>
                                                        <button
                                                            className="btn btn-primary text-uppercase txtside-btn txtht-btn blue"
                                                            type="submit" onClick={() => this.SearchShip(1)}>Search
                                                        </button>
                                                        <button
                                                            className="btn btn-light text-uppercase txtside-btn txtht-btn ml-3"
                                                            type="button" onClick={() => this.ClearInput()}> {" "} Clear{" "}
                                                        </button>
                                                    </div>
                                                </div> */}
          {/* <div className="col-lg-6">
                                                    <label></label><br></br>
                                                    <div className="form-group mt-3 search-btn-col" style={{ textAlign: "end" }}>
                                                        <button
                                                            className="btn btn-primary text-uppercase txtside-btn txtht-btn blue"
                                                            type="submit" onClick={() => this.SearchShip(1)}>
                                                            Search
                                                        </button>
                                                        <button
                                                            className="btn btn-light text-uppercase txtside-btn txtht-btn ml-3"
                                                            type="button" onClick={() => this.ClearInput()}>
                                                            {" "} Clear{" "}
                                                        </button>
                                                    </div>
                                                </div>
                                            </div>
                                        </div>
                                    </div>
                                </div>
                            </div> */}
          {SearchShip ? (
            <ShipManagementCard
              arraylist={SearchShip.data}
              pageSize={SearchShip.pagination.pageSize}
              currentPage={SearchShip.pagination.currentPage}
              totalRecords={
                SearchShip.pagination.totalcount
                  ? SearchShip.pagination.totalcount
                  : 0
              }
              setUpdatedState={(value) => this.SearchShip(value)}
              eyeclick={(item) => this.eyeclick(item)}
            />
          ) : (
            ""
          )}
        </div>
      </div>
    );
  }
}
function mapDispatchToProps(dispatch) {
  return {
    dispatch,
  };
}
function mapStateToProps(state) {
  return {
    showSidePane: state.SidePanReducer.sidePan || false,
    SearchShip: state.POViewReducer.SearchShip,
  };
}
export default withRouter(
  connect(mapStateToProps, mapDispatchToProps)(ShipManagement)
);
